export const generatePlans = ({ plans, t, styles }) => {
    const formattedPlans = plans.map(planData => {
        const {
            credits,
            isPopular,
            price,
            originalTotalAmount,
            discountPercentage,
            pricePerCredit,
            productName,
            currency,
            stripeProductId,
        } = planData;

        const benefits = [{ text: t('plans.youWillGet'), tooltip: t('tooltip.youWillGet') }];

        if (credits > 1) {
            benefits.push({ text: `${credits} ${t('plans.moreExtra')}`, tooltip: t('tooltip.moreExtra') });
        }

        let priceWithDiscountJsx;

        if (discountPercentage && discountPercentage > 0) {
            priceWithDiscountJsx = (
                <span>
                    {t('plans.payInfoStart')}&nbsp;
                    <span className={styles.priceWithDiscountBold}>{`${currency} ${price}`}</span>&nbsp;
                    {t('plans.payInfoEnd')}&nbsp;
                    <span
                        className={styles.priceWithDiscountStrikethrough}
                    >{`${currency} ${originalTotalAmount}`}</span>
                </span>
            );
        } else {
            priceWithDiscountJsx = t('plans.fullPrice');
        }

        return {
            stripeProductId,
            title: `${t('plans.check')} ${credits} ${credits === 1 ? t('plans.carSingle') : t('plans.carPlural')}`,
            price: pricePerCredit,
            currency,
            discount: discountPercentage ? `-${discountPercentage}%` : '0%',
            description: t('plans.sub'),
            priceWithDiscount: priceWithDiscountJsx,
            buttonText: t('plans.buttonSelect'),
            isPopular,
            benefits,
            productName,
            credits,
        };
    });

    return formattedPlans;
};
